import { AuthenticationContext, adalFetch /*, withAdalLogin*/ } from "react-adal";
import { getAsync } from "utils/net";

const securityFeatures: {
  [key: string]: string[];
} = require("./SecurityFeatures.json");

const adalConfig = {
  tenant: "",
  clientId: "",
  cacheLocation: "localStorage",
  endpoints: {
  }
};

export let role: string;
export let authContext: any;
export let authEnabled = false;

// TODO REMOVE: It seems to be unused
// export const groups = {
//   security: "",
//   admin: "",
//   approvers: "",
// };
export let anonymousUserName = "";

// Authentication settings are stored in .env file
export const initializeAuth = () => {
  authEnabled = process.env.REACT_APP_AUTH_ENABLED === "true";

  anonymousUserName = process.env.REACT_APP_AUTH_ANONYMOUS_USERNAME!;
  role = process.env.REACT_APP_AUTH_ANONYMOUS_ROLE!;

  if (authEnabled) {
    adalConfig.tenant = process.env.REACT_APP_AUTH_TENANT_ID!;
    adalConfig.clientId = adalConfig.endpoints[document.location.origin] = process.env.REACT_APP_AUTH_CLIENT_ID!;

    // groups.security = settings.security.securityGroupId;
    // groups.admin = settings.security.adminGroupId;
    // groups.approvers = settings.security.approversGroupId;

    authContext = new AuthenticationContext(adalConfig);
  }
};

export const getUserName = () => {
  return authContext ? authContext._user.userName : anonymousUserName;
}

export const getUserRoleAsync = async () => {
  if (authEnabled) {
    const upn = getUserName();
    const reply = await getAsync(`/api/UserManagement/${upn}`);
    const payload = await reply.text();
    role = payload;
  }
}

export const checkRole = (feature: string) => {
  const enabledRoles = securityFeatures[feature];
  return enabledRoles && enabledRoles.some(r => r === role)
};

export const checkUser = (s: string | undefined) => {
  return getUserName() === s;
};

export const adalApiFetch = (url: string, options?: RequestInit) =>
  authEnabled
    ? adalFetch(authContext, adalConfig.endpoints[document.location.origin], fetch, url, options) :
    fetch(url, options);



// WEBPACK FOOTER //
// ./src/security/security.ts